/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrebidSourceResponseDetailDto } from '../../models/prebid-source-response-detail-dto';

export interface GetMongoDataPrebidSourceResponse$Params {
  id: string;
  'X-API-Version'?: string;
}

export function getMongoDataPrebidSourceResponse(http: HttpClient, rootUrl: string, params: GetMongoDataPrebidSourceResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidSourceResponseDetailDto>> {
  const rb = new RequestBuilder(rootUrl, getMongoDataPrebidSourceResponse.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidSourceResponseDetailDto>;
    })
  );
}

getMongoDataPrebidSourceResponse.PATH = '/api/mongo-data/prebid-source-responses/{id}';
